import { Alert, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import "./PromotionSelectionBar.css";

/** Haftende Auswahlleiste fuer das Stage-Board. Erscheint, sobald mindestens ein Paket ausgewaehlt ist. */
export default function PromotionSelectionBar({ title, subtitle, warning, primaryLabel, primaryDisabled = false, onPrimary, onClear, extraActions }) {
  const { t } = useTranslation("freigabe");
  return <div className="promotion-selection-bar" role="region" aria-label={t("promotion.selectionRegion")}>
    <div className="promotion-selection-bar-text">
      <Typography component="b" className="promotion-selection-bar-title">{title}</Typography>
      {subtitle && <Typography component="small" className="promotion-selection-bar-subtitle">{subtitle}</Typography>}
      {warning && <Alert severity="warning" className="promotion-selection-bar-warning">{warning}</Alert>}
    </div>
    <div className="promotion-selection-bar-actions">
      <Button type="button" variant="outlined" className="promotion-head-button" onClick={onClear}>{t("promotion.clearSelection")}</Button>
      {extraActions}
      <Button type="button" variant="contained" className="promotion-head-button" disabled={primaryDisabled} onClick={onPrimary}>{primaryLabel}</Button>
    </div>
  </div>;
}
